import { render } from "./DigitalMarketing.vue?vue&type=template&id=7a2c3c24&scoped=true"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js"

import "./DigitalMarketing.vue?vue&type=style&index=0&id=7a2c3c24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2c3c24"]])

export default __exports__